'use client';
import { useEffect, useState } from 'react';
import CloseIcon from '@repo/ui/src/components/Icons/CloseIcon';
import Button from '@repo/ui/src/components/Button';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import FilterAccordion from './_FilterAccordion';
import { classNames } from '@repo/ui/src/utils/classNames';

const FilterDrawer = ({ open, onClose, filters, currentFilters, setFilters, clearFilters }) => {
  const { t } = useTranslation();
  const [isAnimating, setIsAnimating] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setIsVisible(true);
  
      const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
  
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollBarWidth}px`;
  
      const timer = setTimeout(() => setIsAnimating(true), 10);
      return () => clearTimeout(timer);
    } else {
      setIsAnimating(false);
      const timer = setTimeout(() => {
        setIsVisible(false);
  
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [open]);

  if (!isVisible) return null;

  const headerId = "filter-drawer-heading";

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className={classNames(
        'tw-fixed tw-inset-0 tw-z-modal tw-overflow-hidden tw-transition-opacity tw-duration-300 tw-bg-black tw-bg-opacity-50',
        isAnimating ? 'tw-opacity-100' : 'tw-opacity-0'
      )}
      onClick={handleBackdropClick}
    >
      <div 
        className={classNames(
          'tw-fixed tw-left-0 tw-top-0 tw-h-full tw-px-2 tw-bg-white tw-shadow-lg tw-flex tw-flex-col tw-min-w-[300px]',
          'tw-transition-transform tw-duration-300 tw-ease-in-out tw-overflow-y-auto',
          isAnimating ? 'tw-translate-x-0' : 'tw-translate-x-[-100%]'
        )}
        role="dialog"
        aria-modal="true"
        aria-labelledby={headerId}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="tw-flex tw-justify-end tw-pb-2">
          <button
            data-dismiss="modal"
            aria-label={t('common.close', undefined, { default: 'Close' })}
            onClick={onClose}
            className="tw-p-2"
          >
            <CloseIcon />
          </button>
        </div>
        <div className="tw-px-6 tw-pt-12 tw-pb-1">
          <div className="tw-flex tw-justify-between tw-items-center tw-mb-2">
            <h2 id={headerId} className="tra-text-web-heading-5 tw-mb-4">
              {t('recipeCategory.filters', undefined, { default: 'Filters' })}
            </h2>
            <Button
              onClick={() => clearFilters()}
              variant="bare"
              size="small"
              className="tw-text-brand-400"
            >
              {t('recipeCategory.clearAll', undefined, { default: 'Clear All' })}
            </Button>
          </div>
          {filters?.map((filter, i) => (
            <FilterAccordion
              currentFilters={currentFilters}
              setFilters={setFilters}
              key={`filter_accordion_${i}`}
              filter={filter}
              index={i}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FilterDrawer;
